/**
 * Dark Mode Functionality
 *
 * This file handles toggling dark mode and storing the preference in the session.
 */

document.addEventListener('DOMContentLoaded', function() {
    const darkModeToggle = document.getElementById('dark-mode-toggle');
    const darkModeIcon = document.getElementById('dark-mode-icon');

    // Function to toggle dark mode
    function toggleDarkMode() {
        if (document.body.classList.contains('dark-mode')) {
            // Switch to light mode
            document.body.classList.remove('dark-mode');
            darkModeIcon.classList.remove('fa-sun');
            darkModeIcon.classList.add('fa-moon');
            // Store preference in session via AJAX
            storePreference('light');
            localStorage.setItem('theme', 'light');
        } else {
            // Switch to dark mode
            document.body.classList.add('dark-mode');
            darkModeIcon.classList.remove('fa-moon');
            darkModeIcon.classList.add('fa-sun');
            // Store preference in session via AJAX
            storePreference('dark');
            localStorage.setItem('theme', 'dark');
        }

        // Dispatch custom event for other components to react
        window.dispatchEvent(new CustomEvent('dark-mode-toggled', {
            detail: { darkMode: document.body.classList.contains('dark-mode') }
        }));

        // If ApexCharts exists, reload the page to refresh charts with new theme
        // This is a simple solution that ensures charts are properly themed
        if (typeof ApexCharts !== 'undefined' && document.querySelector('[data-chart-load]')) {
            setTimeout(() => {
                window.location.reload();
            }, 300);
        }
    }

    // Function to store preference in session
    function storePreference(mode) {
        fetch('/user/settings/theme', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            body: JSON.stringify({ theme: mode })
        })
        .catch(error => console.error('Error storing theme preference:', error));
    }

    // Add click event listener to dark mode toggle
    if (darkModeToggle) {
        darkModeToggle.addEventListener('click', function(e) {
            e.preventDefault();
            toggleDarkMode();
        });
    }

    // Check if dark mode is enabled in session and apply it
    function applyStoredTheme() {
        // Check localStorage first (for better UX before AJAX completes)
        const storedTheme = localStorage.getItem('theme');
        if (storedTheme === 'dark') {
            document.body.classList.add('dark-mode');
            if (darkModeIcon) {
                darkModeIcon.classList.remove('fa-moon');
                darkModeIcon.classList.add('fa-sun');
            }
        }

        // Then check session via AJAX (and update localStorage if different)
        fetch('/user/settings/theme', {
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(response => response.json())
            .then(data => {
                if (data.theme) {
                    localStorage.setItem('theme', data.theme);
                    if (data.theme === 'dark' && !document.body.classList.contains('dark-mode')) {
                        document.body.classList.add('dark-mode');
                        if (darkModeIcon) {
                            darkModeIcon.classList.remove('fa-moon');
                            darkModeIcon.classList.add('fa-sun');
                        }
                    } else if (data.theme === 'light' && document.body.classList.contains('dark-mode')) {
                        document.body.classList.remove('dark-mode');
                        if (darkModeIcon) {
                            darkModeIcon.classList.remove('fa-sun');
                            darkModeIcon.classList.add('fa-moon');
                        }
                    }
                }
            })
            .catch(error => console.error('Error fetching theme preference:', error));
    }

    // Apply stored theme on page load
    applyStoredTheme();
});
